<div class="container page-content">
  <div class="row">
    <div class="col-md-12" style="text-align: center;">
      <h2>{{nombreEncuesta}}</h2>
    </div>
  </div>

  <div class="instruccions">
    <p *ngFor="let instruccion of instrucciones">
      {{instruccion.descripcion}}
    </p>
    <h5>INSTRUCCIONES</h5>
    <p *ngFor="let instruccion of instrucciones" [innerHtml]="instruccion.instrucciones">

    </p>
    <hr>
  </div>
  <div *ngIf = showDatos()>
    <div class="row">
      <div class = "col-sm-12 col-md">
        <ul class="items">
          <li
            *ngFor="let dato of datos"
            class="items__item"
            [ngSwitch]="dato.tipo_campo"
          >
          <ng-template ngSwitchCase="1">
            <div class="card bg-lighth mb-3">
              <div class="card-header">
                {{dato.codigo_campo}}
              </div>
              <div class="card-body">
                <input
                  id = "dato.campo_id"
                  type="number"
                  style="width: 90%;"
                  class="form-control"
                  [(ngModel)]="dato.respuesta"
                />
              </div>
              <div style="margin: 1%">
                <div id="alert-{{dato.campo_id }}" *ngIf="dato.error" class="alert alert-danger" role="alert">
                  Este campo es obligatorio.
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngSwitchCase="2">
            <div class="card bg-lighth mb-3">
              <div class="card-header">
                {{dato.codigo_campo}}
              </div>
              <div class="card-body">
                <input
                  id = "dato.campo_id"
                  type="text"
                  style="width: 90%;"
                  class="form-control"
                  [(ngModel)]="dato.respuesta"
                />
              </div>
              <div style="margin: 1%">
                <div id="alert-{{dato.campo_id }}" *ngIf="dato.error" class="alert alert-danger" role="alert">
                  Este campo es obligatorio.
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngSwitchCase="3">
            <div class="card bg-lighth mb-3">
              <div class="card-header">
                {{dato.codigo_campo}}
              </div>
              <div class="card-body">
                <select
                  id="dato.campo_id"
                  style="width: 90%"
                  class="browser-default custom-select"
                  [(ngModel)]="dato.respuesta"
                >
                  <option *ngFor="let opcion of dato.opciones" [ngValue]="opcion">{{opcion}}</option>
                </select>
              </div>
              <div style="margin: 1%">
                <div id="alert-{{dato.campo_id }}" *ngIf="dato.error" class="alert alert-danger" role="alert">
                  Este campo es obligatorio.
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ngSwitchCase="4">
            <div class="card bg-lighth mb-3">
              <div class="card-header">
                {{dato.codigo_campo}}
              </div>
              <div class="card-body">
                <input
                  type="date"
                  style="width: 90%;"
                  class="form-control"
                  [(ngModel)]="dato.respuesta"
                />
              </div>
              <div style="margin: 1%">
                <div id="alert-{{dato.campo_id }}" *ngIf="dato.error" class="alert alert-danger" role="alert">
                  Este campo es obligatorio.
                </div>
              </div>
            </div>
          </ng-template>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <button
        type="button"
        style="width: 100%"
        class="btn btn-primary"
        id="datos"
        (click)="checkDatos()"
      >
        Continuar
      </button>
      </div>
    </div>
  </div>

  <div *ngIf="showQuestions()">
    <div class="row">
      <div class="col-sm-12 col-md">
        <ul class="items">
          <li
            *ngFor="let pregunta of preguntas"
            class="items__item"
            [ngSwitch]="pregunta.tipo_pregunta"
          >
            <ng-template ngSwitchCase="0">
              <div class="card bg-lighth mb-3" *ngIf="showQuestion(pregunta.respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body">
                  <table style="width: 100%;">
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          <ng-template ngSwitchCase="0">
                            {{respuesta.respuesta_texto}}
                            <input
                              type="text"
                              style="width: 90%;"
                              class="form-control"
                              id="{{
                                'pr_' +
                                  pregunta.pregunta_id +
                                  '_res_' +
                                  respuesta.respuesta_id
                              }}"
                              [(ngModel)]="respuesta.respuesta_valor"
                            />
                          </ng-template>  
                          <ng-template ngSwitchCase="5">
                            {{respuesta.respuesta_texto}}
                            <input
                            style="width: 90%;"
                              type="number"
                              max="200"
                              min="0"
                              class="form-control"
                              id="{{
                                'pr_' +
                                  pregunta.pregunta_id +
                                  '_res_' +
                                  respuesta.respuesta_id
                              }}"
                              [(ngModel)]="respuesta.respuesta_valor"
                            />
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="1">
              <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body">
                  <table>
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          <ng-template ngSwitchCase="0">
                            <label
                              for="preg_{{ pregunta.pregunta_id }}_res_{{
                                respuesta.respuesta_id
                              }}"
                            >
                              <input
                                id="preg_{{ pregunta.pregunta_id }}_res_{{
                                  respuesta.respuesta_id
                                }}"
                                [value]="respuesta.respuesta_id"
                                type="radio"
                                name="radios_{{ pregunta.pregunta_id }}"
                                [(ngModel)]="pregunta.seleccion"
                              />
                              {{ respuesta.respuesta_texto }}
                            </label>
                          </ng-template>
                          <ng-template ngSwitchCase="2">
                            <label
                              for="preg_{{ pregunta.pregunta_id }}_res_{{
                                respuesta.respuesta_id
                              }}"
                            >
                              <input
                                id="preg_{{ pregunta.pregunta_id }}_res_{{
                                  respuesta.respuesta_id
                                }}"
                                [value]="respuesta.respuesta_id"
                                type="radio"
                                name="radios_{{ pregunta.pregunta_id }}"
                                [(ngModel)]="pregunta.seleccion"
                              />
                              {{ respuesta.respuesta_texto }}
                              <ng-template
                                [ngIf]="
                                  pregunta.seleccion == respuesta.respuesta_id
                                "
                              >
                                <input
                                  type="text"
                                  name="other_preg_{{ pregunta.pregunta_id }}"
                                  [(ngModel)]="respuesta.respuesta_valor"
                                />
                              </ng-template>
                            </label>
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="2">
              <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body"  style="margin-left: 1%">
                  <table>
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          <ng-template ngSwitchCase="0">
                            <label
                              for="preg_{{ pregunta.pregunta_id }}_res_{{
                                respuesta.respuesta_id
                              }}"
                            >
                              <input
                                id="preg_{{ pregunta.pregunta_id }}_res_{{
                                  respuesta.respuesta_id
                                }}"
                                type="checkbox"
                                class="form-check-input"
                                name="radios"
                                [(ngModel)]="respuesta.seleccionada"

                              />
                              &nbsp;{{ respuesta.respuesta_texto }}
                            </label>
                          </ng-template>
                          <ng-template ngSwitchCase="2">
                            <label
                              for="preg_{{ pregunta.pregunta_id }}_res_{{
                                respuesta.respuesta_id
                              }}"
                            >
                              <input
                                id="preg_{{ pregunta.pregunta_id }}_res_{{
                                  respuesta.respuesta_id
                                }}"
                                type="checkbox"
                                class="form-check-input"
                                name="radios"
                                [(ngModel)]="respuesta.seleccionada"
                              />
                              &nbsp;Otro
                              <ng-template
                                [ngIf]="respuesta.seleccionada"
                              >
                                <input
                                  type="text"
                                  name="other_preg_{{ pregunta.pregunta_id }}"
                                  [(ngModel)]="respuesta.respuesta_valor"
                                />
                              </ng-template>
                            </label>
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngSwitchCase="3">
            <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.respuesta_padre)">
              <div class="card-header">
                {{pregunta.numero_pregunta}}. {{pregunta.pregunta_valor}}
              </div>
              <table>
                <tr *ngFor="let respuesta of pregunta.respuestas">
                  <td>
                    <div [ngSwitch]="respuesta.tipo_respuesta">
                      <ng-template ngSwitchCase="6">
                        <div class="container">
                        <div class="row">
                          Departamento:
                        </div>
                         <div class="row">
                          <select
                          [(ngModel)]="respuesta.respuesta_valor"
                          style="width: 90%"
                          class="browser-default custom-select"
                          (change)="getMunicipios(respuesta.respuesta_valor,pregunta)"
                        >
                        <option *ngFor="let c of ubicaciones"
                         [ngValue]="c.departamento">{{c.departamento}}</option>
                        </select>
                         </div>
                         <div class="row">
                          Municipio:
                         </div>
                            <div class="row">
                              <select
                              [(ngModel)]="respuesta.seleccionada"
                              style="width: 90%"
                              class="browser-default custom-select"
                            >
                            <option *ngFor="let m of pregunta.lista_respuestas" [ngValue]="m.id">{{m.municipio}}</option>
                            </select>
                            </div>
                            <div class="row">
                              Zona:
                            </div>
                            <div class="row">
                              <select
                              [(ngModel)]="respuesta.respuesta_valor2"
                              style="width: 90%"
                              class="browser-default custom-select"
                              >
                              <option *ngFor="let z of zonas" [ngValue]="z">{{z}}</option>
                            </select>
                            </div>
                          </div>

                      </ng-template>
                    </div>
                  </td>
                </tr>
              </table>
              <div style="margin: 1%">
                <div
                  id="alert-{{ pregunta.pregunta_id }}"
                  *ngIf="pregunta.error"
                  class="alert alert-danger"
                  role="alert"
                >
                  Esta pregunta es obligatoria.
                </div>
              </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="4">
              <div class="card card bg-light mb-3">
                <div class="card-header">
                  {{pregunta.numero_pregunta}}.{{pregunta.pregunta_valor}}
                </div>
                <div class="card-body"  style="margin-left: 1%">
                  <table style="width: 100%">
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          <ng-template ngSwitchCase="0">
                            <select
                              [(ngModel)]="respuesta.prioridad"
                              style="width: 50%"
                              class="browser-default custom-select"
                            >
                              <option *ngFor="let respuestaA of pregunta.respuestas; let i=index" value="{{i+1}}"> {{i+1}}</option>
                            </select>
                            {{respuesta.respuesta_texto}}
                          </ng-template>
                          <ng-template ngSwitchCase="2">
                            <label
                              for="preg_{{ pregunta.pregunta_id }}_res_{{
                                respuesta.respuesta_id
                              }}"
                            >
                              <input
                                id="preg_{{ pregunta.pregunta_id }}_res_{{
                                  respuesta.respuesta_id
                                }}"
                                type="checkbox"
                                class="form-check-input"
                                name="radios"
                                [(ngModel)]="respuesta.seleccionada"
                              />
                              &nbsp;Otro
                              <ng-template
                                [ngIf]="
                                  respuesta.respuesta_valor ==
                                  respuesta.respuesta_id
                                "
                              >
                                <input
                                  type="text"
                                  name="other_preg_{{ pregunta.pregunta_id }}"
                                />
                              </ng-template>
                            </label>
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert">
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="5">
              <div class="card card bg-light mb-3"  *ngIf="showQuestion(pregunta.respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body"  style="margin-left: 1%">
                  <table style="width: 90%">
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          <ng-template ngSwitchCase="3">
                            <div class="container" style="width: 100%;">

                            <input style="width: 45%;"
                              type="time"
                              [(ngModel)]="respuesta.respuesta_valor"
                              value="00:00"
                            />
                            A
                            <input style="width: 45%;"
                              type="time"
                              [(ngModel)]="respuesta.respuesta_valor2"
                              value="00:00"
                            />
                          </div>
                          </ng-template>
                          <ng-template ngSwitchCase="4">
                            <input  style="width: 90%; align-self: center;"
                              [(ngModel)]="respuesta.respuesta_valor"
                              type="time"
                              value="00:00"
                            />
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="6">
              <div class="card card bg-light mb-3">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body"  style="margin-left: 1%">
                  <mat-form-field appearance="fill" style="width: 90%;">
                    <mat-select multiple [(ngModel)]="pregunta.lista_respuestas">
                      <mat-option
                        *ngFor="let respuesta of pregunta.respuestas"
                        [value]="respuesta.respuesta_id"
                        >{{ respuesta.respuesta_valor }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="7">
              <div class="card card bg-light mb-3">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body"  style="margin-left: 1%"></div>
                <div class="row">
                  <div class="col-md-1"></div>
                  <div class="col-md-5" style="float: none; margin: auto">
                    <table style="max-width: 100%" border="1">
                      <tbody
                        *ngFor="
                          let respuesta of pregunta.respuestas;
                          let i = index
                        "
                      >
                        <tr *ngIf="i % 2 == 0">
                          <td style="white-space: nowrap">
                            <img
                              (click)="
                                open(
                                  eventmodal,
                                  respuesta.descripcion,
                                  pregunta.lista_respuestas,
                                  respuesta.respuesta_id
                                )
                              "
                              style="width: 75px; height: 75px"
                              src="{{ respuesta.respuesta_url }}"
                            />
                          </td>
                          <td
                            style="white-space: nowrap"
                            *ngIf="i < pregunta.respuestas.length - 1"
                          >
                            <img
                              (click)="
                                open(
                                  eventmodal,
                                  pregunta.respuestas[i + 1].descripcion,
                                  pregunta.lista_respuestas,
                                  pregunta.respuestas[i+1].respuesta_id
                                )
                              "
                              style="width: 75px; height: 75px"
                              src="{{ pregunta.respuestas[i + 1].respuesta_url }}"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="col-md-6">
                    <div class="row" style="margin: 5%">
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="removeEntry(pregunta.lista_respuestas)"
                      >
                        Remover ultimo
                      </button>
                    </div>
                    <div class="row">
                      <mgl-timeline [toggle]="toggle" [side]="side">
                        <mgl-timeline-entry
                          style="width: 100%"
                          *ngFor="
                            let entry of pregunta.lista_respuestas;
                            let i = index
                          "
                     (expand)="onExpandEntry($event, i)"
                        >
                          <mgl-timeline-entry-header
                            (click)="onHeaderClick($event)"
                          >
                            <div>{{ entry.numero }}. {{ entry.nombre }}</div>
                          </mgl-timeline-entry-header>
                          <mgl-timeline-entry-content
                            [expandAnimationTiming]="
                              contentAnimation ? '200ms ease' : '0ms'
                            "
                            [collapseAnimationTiming]="
                              contentAnimation ? '100ms ease' : '0ms'
                            "
                          >
                            <div>
                              <div>{{ entry.tiempo }} minutos</div>

                            </div>
                          </mgl-timeline-entry-content>
                          <mgl-timeline-entry-dot
                            [class]="color ? 'primary' : 'accent'"
                            [size]="size"
                            (click)="onDotClick($event)"
                            [expandAnimationTiming]="
                              dotAnimation ? '200ms ease' : '0ms'
                            "
                            [collapseAnimationTiming]="
                              dotAnimation ? '100ms ease' : '0ms'
                            "
                          ></mgl-timeline-entry-dot>
                          <mgl-timeline-entry-side> </mgl-timeline-entry-side>
                        </mgl-timeline-entry>
                      </mgl-timeline>
                    </div>
                  </div>
                </div>
                <div style="margin: 1%">
                  <div
                    id="alert-{{ pregunta.pregunta_id }}"
                    *ngIf="pregunta.error"
                    class="alert alert-danger"
                    role="alert"
                  >
                    Esta pregunta es obligatoria.
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template  ngSwitchCase="8"> <!-- Pregunta tipo checkbox e input Tipo 8 -->
              <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body"  style="margin-left: 1%">
                  <table>
                    <tr *ngFor="let respuesta of pregunta.respuestas">
                      <td>
                        <div [ngSwitch]="respuesta.tipo_respuesta">
                          
                          <ng-template ngSwitchCase="7">
                            <div class="d-flex align-items-center mb-2" style="gap: 0.5rem;">
                              <!-- Checkbox and label -->
                              <div class="form-check">
                                <input
                                  id="preg_{{ pregunta.pregunta_id }}_res_{{ respuesta.respuesta_id }}"
                                  type="checkbox"
                                  class="form-check-input"
                                  name="radios"
                                  [(ngModel)]="respuesta.seleccionada"
                                />
                                <label
                                  class="form-check-label"
                                  for="preg_{{ pregunta.pregunta_id }}_res_{{ respuesta.respuesta_id }}"
                                >
                                  {{ respuesta.respuesta_texto }}
                                </label>
                              </div>
                            
                              <!-- Description -->
                              <span>{{ respuesta.descripcion }}</span>
                            
                              <!-- Number input -->
                              <input
                                style="width: 90px;"
                                type="number"
                                max="200"
                                min="0"
                                class="form-control"
                                id="pr_{{ pregunta.pregunta_id }}_res_{{ respuesta.respuesta_id }}"
                                [disabled]="!isSelected(respuesta.seleccionada)"
                                [(ngModel)]="respuesta.respuesta_valor"
                              />
                            </div>                            
                          </ng-template>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template  ngSwitchCase="9">
              <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.mult_respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
                <div class="card-body" style="margin-left: 1%">
                  <table class="table table-bordered">
                    <tr>
                      <td><strong>Calidad de la enseñanza</strong></td>
                      <td>Excelente</td>
                      <td>Buena</td>
                      <td>Regular</td>
                      <td>Baja</td>
                      <td>Muy Baja</td>
                    </tr>
                    <ng-container *ngFor="let respuesta of pregunta.respuestas">
                    <tr  *ngIf="showBaseOnAnswer(respuesta.respuesta_padre)">
                      
                      <td>{{ respuesta.respuesta_texto }}</td>
                      <td>
                        <input
                          type="radio"
                          [value]="5"
                          [(ngModel)]="respuesta.respuesta_valor"
                          name="radio_{{ pregunta.pregunta_id }}_{{ respuesta.respuesta_id }}"
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          [value]="4"
                          [(ngModel)]="respuesta.respuesta_valor"
                          name="radio_{{ pregunta.pregunta_id }}_{{ respuesta.respuesta_id }}"
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          [value]="3"
                          [(ngModel)]="respuesta.respuesta_valor"
                          name="radio_{{ pregunta.pregunta_id }}_{{ respuesta.respuesta_id }}"
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          [value]="2"
                          [(ngModel)]="respuesta.respuesta_valor"
                          name="radio_{{ pregunta.pregunta_id }}_{{ respuesta.respuesta_id }}"
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          [value]="1"
                          [(ngModel)]="respuesta.respuesta_valor"
                          name="radio_{{ pregunta.pregunta_id }}_{{ respuesta.respuesta_id }}"
                        />
                      </td>
                    </tr>
                  </ng-container>
                  </table>
                
                  <div style="margin: 1%">
                    <div
                      id="alert-{{ pregunta.pregunta_id }}"
                      *ngIf="pregunta.error"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="10">
              <div class="card card bg-light mb-3" *ngIf="showQuestion(pregunta.mult_respuesta_padre)">
                <div class="card-header">
                  {{ pregunta.numero_pregunta }}. {{ pregunta.pregunta_valor }}
                </div>
            
                <div class="card-body" style="margin-left: 1%">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th><strong>{{ pregunta.pregunta_descripcion }}</strong></th>
                        <ng-container *ngFor="let respuesta of pregunta.respuestas">
                          <th *ngIf="showBaseOnAnswer(respuesta.respuesta_padre)">
                            {{ respuesta.respuesta_texto }}
                          </th>
                        </ng-container>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of getItems(pregunta)">
                        <td>{{ item }}</td>
                        <ng-container *ngFor="let respuesta of pregunta.respuestas">
                          <td *ngIf="showBaseOnAnswer(respuesta.respuesta_padre)">
                            <input
                              type="checkbox"
                              [checked]="isChecked(respuesta.respuesta_valor, item)"
                              (change)="toggleItem(respuesta, item)"
                              [disabled]="isDisabled(respuesta, item, pregunta)"
                            />
                            <input
                            *ngIf="item === 'Otro' && isChecked(respuesta.respuesta_valor, item)"
                            type="text"
                            class="form-control mt-1"
                            placeholder="Especifique..."
                            [(ngModel)]="respuesta.respuesta_valor2"
                            style="width: 100%;"
                          />
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
            
                  <div class="mt-2" *ngIf="pregunta.error">
                    <div class="alert alert-danger" role="alert">
                      Esta pregunta es obligatoria.
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            
                        
            
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <button
        type="button"
        style="width: 100%"
        class="btn btn-primary"
        (click)="checkAnswers()"
        [disabled]="!sendAnswers"
      >
        Enviar Respuestas
      </button>
      </div>
    </div>
  </div>
</div>
<ng-template #eventmodal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Tiempo</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="form-group full-width-input">
        <label>Ingrese el tiempo (minutos) que utiliza este transporte</label>
        <input
          class="form-control"
          placeholder="minutos"
          formControlName="time"
          [(ngModel)]="currentTime"
          required

        />
      </div>
      <div class="button-row">
        <button type="button" class="btn btn-primary" (click)="addTimeEntry()">
          Aceptar
        </button>
        <button type="button" class="btn btn-light" (click)="onCancel()">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</ng-template>
